<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div>
    <app-pageheader [Parent]="this">
      <a class="button is-primary" [routerLink]="['/enforcement/officers', Model.Id, 'edit']">
        <span class="icon"><i class="fas fa-edit"></i></span>
        <span>Edit Officer</span>
      </a>
    </app-pageheader>
    <div class="columns">
      <div class="column is-6">
        <!-- Officer Info Panel -->
        <article class="panel">
          <p class="panel-heading">
            Officer Information
          </p>
          <a class="panel-block">
            <span class="label">Badge</span>
            <span class="value">{{Model.BadgeNumber || 'N/A'}}</span>
          </a>
          <a class="panel-block">
            <span class="label">User</span>
            <span class="value">{{Model.UserName || 'N/A'}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Email</span>
            <span class="value">{{Model.UserEmail || 'N/A'}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Status</span>
            <span class="value">
              <span class="tag" [ngClass]="Model.IsActive ? 'is-success' : 'is-danger'">
                {{Model.IsActive ? 'Active' : 'Inactive'}}
              </span>
            </span>
          </a>
        </article>
        <!-- Notes Panel -->
        <article class="panel">
          <p class="panel-heading">
            Notes
          </p>
          <div class="panel-block">
            @if (!Model.Notes) {
              <p class="has-text-grey is-italic">No notes recorded</p>
            }
            @if (Model.Notes) {
              <p>{{Model.Notes}}</p>
            }
          </div>
        </article>
      </div>
      <div class="column is-6">
        <!-- Statistics Summary Panel -->
        <article class="panel">
          <p class="panel-heading">
            Performance Statistics
          </p>
          @if (statisticsLoading) {
            <div class="panel-block is-block">
              <div class="has-text-centered py-4">
                <span class="icon is-large"><i class="fas fa-spinner fa-spin"></i></span>
                <p>Loading statistics...</p>
              </div>
            </div>
          }
          @if (!statisticsLoading && statistics) {
            <div class="table-container p-2">
              <table class="table is-fullwidth">
                <tbody>
                  <tr>
                    <td>Total Citations Issued</td>
                    <td class="has-text-right has-text-weight-bold">{{statistics.TotalCitationsIssued}}</td>
                  </tr>
                  <tr>
                    <td>Citations This Month</td>
                    <td class="has-text-right has-text-weight-bold">{{statistics.CitationsThisMonth}}</td>
                  </tr>
                  <tr>
                    <td>Citations This Week</td>
                    <td class="has-text-right has-text-weight-bold">{{statistics.CitationsThisWeek}}</td>
                  </tr>
                  <tr>
                    <td>Daily Average</td>
                    <td class="has-text-right has-text-weight-bold">{{statistics.AverageCitationsPerDay | number:'1.1-1'}}</td>
                  </tr>
                  <tr class="has-background-light">
                    <td class="has-text-weight-bold">Total Amount Collected</td>
                    <td class="has-text-right has-text-weight-bold">{{formatCurrency(statistics.TotalAmountCollected)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          }
          @if (!statisticsLoading && !statistics) {
            <div class="panel-block is-block">
              <p class="has-text-grey has-text-centered is-italic py-4">No statistics available</p>
            </div>
          }
        </article>
        <!-- Citations Per Day Chart Panel -->
        @if (statistics && chartData) {
          <article class="panel">
            <p class="panel-heading">
              Citations Last 7 Days
            </p>
            <div class="panel-block is-block">
              <app-generic-bar-chart
                [chartData]="chartData"
                [showLegend]="false"
                [height]="200"
                yAxisLabel="Citations">
              </app-generic-bar-chart>
            </div>
          </article>
        }
      </div>
    </div>
  </div>
}


